import React from 'react';
import Slider from "react-slick";
import GiftCard from './GiftCard';

import etiqueta from '../../../images/planes/etiqueta.png';
import Button from '../../elements/buttons/Button';


const GiftCardsPlanes = () =>{

    const settings = {
        centerMode: true,
        centerPadding: '31%',
        arrows: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '22%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    dots: false,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '21%',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    dots: true,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '280px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    dots: true,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '240px',
                    slidesToShow: 1
                }
                },
            {
            breakpoint: 992,
            settings: {
                dots: true,
                arrows: false,
                centerMode: true,
                infinite: false,
                centerPadding: '140px',
                slidesToShow: 1
            }
            },
            {
                breakpoint: 600,
                settings: {
                    dots: true,
                    arrows: false,
                    centerMode: true,
                    infinite: false,
                    centerPadding: '30px',
                    slidesToShow: 1
                }
            }
            // ,
            // {
            //     breakpoint: 400,
            //     settings: {
            //         dots: true,
            //         arrows: false,
            //         centerMode: true,
            //         infinite: false,
            //         centerPadding: '20px',
            //         slidesToShow: 1
            //     }
            // }
        ]
    }; 
    return( 
    <>
        <section className="GiftCardPlanes" id="giftAnchor">
            <div className="wrap">
                <img src={etiqueta} className="etiqueta" />
                <h3 className="titles">Sorpréndelos con un plan de regalo</h3>
            </div>
            <Slider {...settings}>
                <div>
                    <GiftCard 
                        className=""
                        precio="20"
                        copy="La podrá canjear por sus pelis o series favoritas, o por una suscripción de 30 días."
                        link="/"
                        copyLink="Comprar"
                        classNameLink="button-primary"
                    />
                </div>
                <div>
                    <GiftCard 
                        className=""
                        precio="50"
                        copy="La podrá canjear por sus pelis o series favoritas, o por una suscripción de 30 días."
                        link="/"
                        copyLink="Comprar"
                        classNameLink="button-primary"
                    />
                </div>
                <div>
                    <GiftCard 
                        className=""
                        precio="100"
                        copy="La podrá canjear por sus pelis o series favoritas, o por una suscripción de 30 días."
                        link="/"
                        copyLink="Comprar"
                        classNameLink="button-primary"
                    />
                </div>
            </Slider>

            <div className="TeRegalon">
                <p>¿Te regalaron una Gift Card?</p>
                <Button link="/" className="button-gradient" copy="Canjear" />
            </div>
        </section>
    </>
)
}

export default GiftCardsPlanes;